module.exports = __webpack_public_path__ + "static/media/usage.afa662e6.svg";